// extracted by mini-css-extract-plugin
module.exports = {"switchLang":"locale_switchLang_1-fi0","btnLang":"locale_btnLang_2j6uL","btnActive":"locale_btnActive_A0Sgd"};